import React, { useEffect, useRef, useState } from "react";
import api from "../../seller-apis/api";
import '../order.css';
import { useAlert } from "react-alert";
import { fetchOpportunityData } from '../../seller-apis/apidataField';
import PaginationNew from "../common/Pagination";
import servicesApi from '../../seller-apis/servicesApi';
import Popup from '../common/Popup';
import UpdtProPopup2 from '../common/UpdtProPopup2';
import MatchPriceModal from "../common/MatchPriceModal";
import OrderSKUSearch from "../common/ProductSearch/OrderSKUSearch";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
//SL-698
import CompetitivenessBox from "../common/CompetitivenessBox.js";
import PriceComparisonTable from "../common/PriceComparisonTable.js";

// sl - 719
import competitiveImg1 from '../../assets/images/home-competitve-1.png';
import competitiveImg2 from '../../assets/images/home-competitve-2.png';
import competitiveImg3 from '../../assets/images/home-competitve-3.png';
import MainLoader from "../common/Loader/PageLoader.js";

var globalFilterData = {
  pageNo: 1,
  size: 12,
  filters: {

  },
  sortFilter: { "createdAt": -1 },
};
//set searchParam
var searchParam = {
  "vendors.vActive": 'ACTIVE',//{ "$exists": true, "$ne": "REJECT" },
  "vendors.active": true,
  /*"$and": [
    { "vendors.prSts": { "$exists": true } },
    { "vendors.prSts": { "$ne": "V_PENDING" } }
  ]*/
}

function PriceOpportunity({ updateCount }) {
  const alert = useAlert();
  const [tickets, setTickets] = useState([]);
  const [totalRcord, setTotalReord] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [cbimg, setcbimg] = useState();
  const [selectedProductPopup, setselectedProductPopup] = useState();
  const [updtProVisibility, setupdtProVisibility] = useState(false);
  const [clickedUpdateNo, setclickedUpdateNo] = useState();
  const [updtPopuprel, setupdtPopuprel] = useState([]);
  const [otherSellerPrice, setotherSellerPrice] = useState();
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [matchObject, setMatchObject] = useState(false);
  const [searchPro, setsearchPro] = useState();
  const [searchType, setSearchType] = useState("Product Name");
  const [ennewloader, setennewloader] = useState("none");
  const outerdivRef = useRef(null);
  const loaderDivRef = useRef(null);
  const history = useHistory();
  //SL-698
  const [competitiveness, setCompetitiveness] = useState({});
  //SL-675
  const [totalRcordId, setTotalReordId] = useState([]);
  function applyLoader() {
    if (loaderDivRef.current && outerdivRef.current) {
      loaderDivRef.current.classList.add("loader-bt");
      setennewloader("flex");
      outerdivRef.current.classList.add("div-bk");
    }
  }

  function removeLoader() {
    if (loaderDivRef.current && outerdivRef.current) {
      setennewloader("none");
      loaderDivRef.current.classList.remove("loader-bt");
      outerdivRef.current.classList.remove("div-bk");
    }
  }



  useEffect(() => {
    if (window.location.hash === '#popupDetail') {
      history.replace(window.location.pathname); // Replace the current URL
    }
    globalFilterData = {
      pageNo: 1,
      size: 12,
      filters: {

      },
      sortFilter: { "createdAt": -1 },
    }
    getOpportunity(globalFilterData);
    //SL-698
    getPriceCompetiveness();


  }, []);
  const getOpportunity = (filterData = globalFilterData) => {
    applyLoader()
    //SL-675
    filterData["productId"] = totalRcordId.length == 0 ? true : false;
    api.Opportunity.fetchPriceOpportunity(fetchOpportunityData(filterData)).then((review) => {
      setTotalReord(review.totalRecords);
      //updateCount(review.totalRecords);
      let data = review.data;
      setTickets(data);
      if(totalRcordId.length == 0){//SL-675
        setTotalReordId(review?.productId);
        filterData["productId"] = false;
      }
      removeLoader()
    });
  };


  function paginate(data) {
    setCurrentPage(data.number);
    let filter = globalFilterData;
    filter['pageNo'] = data.number;
    getOpportunity(filter);
  }

  //SL-698
  const getPriceCompetiveness = () => {
    api.Opportunity.getPriceCompetiveness()
      .then((res) => {

        setCompetitiveness(res.data);
      })
      .catch(err => {
        console.log(err)
      })
  }

  //refresh productpopup
  const params = window.location.hash
  useEffect(() => {
    // setpopupVisibilityDetail("");
    if (params) {
      const url = localStorage.getItem("productUrl")
      const price = localStorage.getItem("productPrice")
      let data =
      {
        "filter": { "urlKey": url }
      }
      servicesApi.getProductDetail(data).then((res) => {
        detail([res.data], price)

        setpopupVisibilityDetail("2");
      }).catch(err => console.log(err))
    }

  }, [params])

  // For detail of product
  const detailnew = (url, price) => {
    //set localstorage
    localStorage.setItem("productUrl", url)
    localStorage.setItem("productPrice", price)
    let data =
    {
      "filter": { "urlKey": url }
    }
    servicesApi.getProductDetail(data).then((res) => {
      detail([res.data], price)

      setpopupVisibilityDetail("2");
    }).catch(err => console.log(err))

  }

  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [detailPPrice, setdetailPPrice] = useState("");
  // Popup showing detail
  function detail(data, price) {
    setdetailPPrice(price)

    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }

  //Popup related functions
  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }

  // Check response of product added
  function callbackResponse(msg) {
    if (msg === "product added" || msg === "product updated") {
      setupdtProVisibility(false);
      alert.success("Product Added Successfully");
      getOpportunity(globalFilterData);
    }
    else {
      setupdtProVisibility(false)
      alert.error("Product not added")
    }
  }

  function checkpopupvisibility(e) {
    if (e === false) {
      setupdtProVisibility(false)
    }
    else {
      setupdtProVisibility(true)
    }
  }

  const getPriceMatchObject = (data) => {

    setShowMatchModal(true);
    setMatchObject(data)
  }
  const closeMatchModal = () => {
    setShowMatchModal(false);
    //SL-698
    getPriceCompetiveness();
  }
  // set _id-objectId 
  const filterSearch = (data) => {

    //setsearchPro(data.data);
    //setSearchType(data.type)
    globalFilterData['filters'] = { ...globalFilterData.filters, "_id-objectId": data.data }
    //Search Issue on Other than 1st Page SL-698 and SL-675
    if(globalFilterData?.searchIds)
      delete globalFilterData['searchIds'];
    globalFilterData.pageNo = 1;
    getOpportunity(globalFilterData);
    //SL-698
    if (globalFilterData?.filters && globalFilterData['filters']['_id-objectId'])
      delete globalFilterData['filters']['_id-objectId'];
  }

  const ApiCalling = () => {
    if(globalFilterData?.searchIds)
        delete globalFilterData['searchIds'];
    globalFilterData.pageNo = currentPage;
    getOpportunity(globalFilterData)
  }
  
  /**
   * Search By Keyword On Enter
   */
  const searchByKeyword = (value, type, productIds) => {
    
    if(productIds.length > 0){
      setsearchPro(productIds);
      setSearchType(type)
      globalFilterData['searchIds'] = productIds 
      //Search Issue on Other than 1st Page SL-698 and SL-675
      globalFilterData.pageNo = 1;
      setCurrentPage(1);
      getOpportunity(globalFilterData);
      
    }
    else{
      setTotalReord(0);
      setTickets([]);
    }
    
  
  }
  return (
    <div>
    <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
        <CompetitivenessBox title="Market Competitiveness" icon={competitiveImg1} percent={competitiveness.market} bgColor='#6ED66B'/>
        <CompetitivenessBox title="Other Seller Price" icon={competitiveImg2} percent={competitiveness.competitor} bgColor='#FFCD31'/>
        <CompetitivenessBox title="Overall Performance" icon={competitiveImg3} style={{"marginRight":"20px"}} percent={competitiveness.overall} bgColor='#FC0707'/>
      </div>
      <div className="table-responsive">
        <table className="ord_table new-table-design" style={{ "width": "100%" }}>
          <thead>
            <tr>
              <th style={{width: '10%'}}>
                Product Image
              </th>
              <th style={{ width: '40%' }}>
                Product Details
                <div className='topprodsearch flex-column'>
                  <OrderSKUSearch
                    filterSearch={filterSearch}
                    searchNewEnq={setsearchPro}
                    searchParam={searchParam}
                    from={"orders"}
                    flag="Opportunity" // set falg
                    apiCall={ApiCalling}
                    data="filedData"
                    totalRcordId={totalRcordId}
                    searchByKeyword={searchByKeyword}
                  />
                </div>
              </th>
              <th style={{width: '20%'}}>Current Transfer<br />Price<br /><span style={{ color: 'grey' }}>(Incl. GST)</span></th>
              {/*Price Analysis Ticket: SL-698 */}
              <th style={{width: '30%'}}>Price Analysis</th>

            </tr>
          </thead>
          <tbody id="orDeskContain" ref={outerdivRef}>
            {tickets.length > 0 && tickets.map((ticket, index) => {
              let baseImg;
              ticket.images.map((item) => {
                if (item.baseImage === true) {
                  if (item.image.startsWith("products")) {
                    baseImg = item.image;
                  }
                  else {
                    let img = item.image.substr("41")
                    baseImg = img;
                  }
                }
              })
              return (
                <>
                  <tr>
                    <td className="td-img-cntn">
                      <div className='border-x'>
                        <img src={"https://s3.toolsvilla.com/" + baseImg} alt="img" className="px-2 product-i mx-1" />
                      </div>
                    </td>
                    <td className='fs-13 order_table_pname_cntn'>
                      <div className='border-x inline-initial'>
                        <a href='#popupDetail' onClick={() => detailnew(ticket.urlKey, ticket?.productId?.price)} className='prod-name'>{ticket.productName}</a>
                        <div className='order_table_sku'>SKU:- {ticket.SKU}</div>
                        {Array.isArray(ticket.combination) && ticket.combination.length > 0 &&
                          <div className="product-package-details">
                            {Array.isArray(ticket.combination) && ticket.combination.length > 0 && ticket.combination.map((item, index) => {
                              return (
                                <>
                                  {index == 0 &&
                                    <div key={index} className="type" value={`${ticket.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock}`}>{item.value[0]}</div>
                                  }
                                  {index > 0 &&
                                    <div className={`comb ${index == 1 && "active"}`} key={index} value={`${ticket.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock}`}>{item.value[0]}</div>
                                  }</>
                              )
                            })}
                          </div>}
                        {Array.isArray(ticket?.combination) && ticket?.combination.length > 0 &&
                          <div className="product-package-details">
                            {Array.isArray(ticket?.combination) && ticket?.combination.length > 0 && ticket?.combination.map((item, index) => {
                              return (
                                <>
                                  {index == 0 &&
                                    <div key={index} className="type" value={`${ticket.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock}`}>{item.value[1]}</div>
                                  }
                                  {index > 0 &&
                                    <div className={`comb ${index == 1 && "active"}`} key={index} value={`${ticket.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock}`}>{item.value[1]}</div>
                                  }</>
                              )
                            })}
                          </div>}
                        <a href='#popupDetail' onClick={() => detailnew(ticket.urlKey, ticket?.productId?.price)} className='detail-but'>
                          <button className='p-2 order_table_btn_details'>View Details</button>
                        </a>
                      </div>
                    </td>
                    {/* Current Transfer Price */}
                    <td>
                      <div className='border-x'>
                        <div className='prod-price black-color' style={{ fontSize: '12px', fontWeight: '400' }}><i class="fa fa-inr" aria-hidden="true"></i> {Math.floor(ticket?.vendor?.[0]?.purchase_price)}</div>
                      </div>
                    </td>
                    {/*Price Analysis Ticket: SL-698 */}
                    <td>
                      <div className='border-x'>
                        <PriceComparisonTable mProduct={ticket} getPriceMatchObject={getPriceMatchObject} />
                      </div>
                    </td>

                  </tr>
                </>
              );
            })}
            {tickets.length === 0 && (
               <tr>
               <td colSpan={4} style={{ textAlign: 'center', padding: '1rem' }}>
                 No record found!
               </td>
             </tr>
            )}

          </tbody>
        </table>
      </div>
      <PaginationNew
        number={totalRcord}
        paginate={paginate}
        activ={currentPage}
        comp={"support"}
      />
      <div class="d-flex justify-content-center" id="enNewLoader" ref={loaderDivRef}>
        <div
          style={{ display: ennewloader }}
        >
         <MainLoader/>
        </div>
      </div>

      <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
        <Popup
          from="newOrder"
          description={productDetail[0].description}
          sdescription={productDetail[0].shortDescription}
          descriptionNew={productDetail[0].descriptionNew}
          name={productDetail[0].productName}
          price={detailPPrice}
          pkgs={productDetail[0]?.pkgs}
          manufacturerName={productDetail[0]?.manufacturerName}
          SKU={productDetail[0].SKU}
          popupVisibility={setpopupVisibilityDetail}
          images={productDetail[0].images}
          videos={productDetail[0].videos}
        />
      </div>

      {updtProVisibility === true ?
        <UpdtProPopup2
          lead={clickedUpdateNo}
          productName={selectedProductPopup}
          Popupvisible="block"
          img={cbimg}
          pkgs={productDetail[0]?.pkgs}
          manufacturerName={productDetail[0]?.manufacturerName}
          detail={updtPopuprel}
          lowestPrice={otherSellerPrice}
          Popupvisibilityfun={checkpopupvisibility}
          from="chooseProduct"
          callbackResFun={callbackResponse}
        /> : <></>
      }
      {showMatchModal &&
        <MatchPriceModal
          otherPrice={matchObject?.lowestPrice}
          getProducts={getOpportunity}
          show={showMatchModal}
          SKU={matchObject?.SKU}
          url={matchObject?.url}
          productId={matchObject?.productId}
          handleClose={closeMatchModal}
          receivedFrom="Pricing Opp"
        />
      }
    </div>
  );
}

export default PriceOpportunity;